<template>
    <v-container>
        <v-card>
            <v-card-title>
                <h3>Veículos</h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-text-field v-model="search" prepend-icon="mdi-car" label="Pesquisar"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn @click="system.diagCadVeiculo = !system.diagCadVeiculo" color="primary" large dark>
                            <v-icon left>mdi-car</v-icon>
                            Novo
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- <v-list two-line>
                    <v-list-item v-for="empresa in empresas" :key="empresa.index">
                        <v-list-item-icon>
                            <v-icon>mdi mdi-car</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                        <v-list-item-title>{{empresa.empresa}}</v-list-item-title>
                        <v-list-item-subtitle>
                            <div class="green--text">Disponível</div>
                        </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon color="blue lighten-1">mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="true">
                                        <v-list-item-avatar>
                                            <v-icon>mdi-file-document</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-title>Gerar Fatura</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="true">
                                        <v-list-item-avatar>
                                            <v-icon>mdi-barcode</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-title>Gerar Boleto</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="true">
                                        <v-list-item-avatar>
                                            <v-icon>mdi-file-document</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-title>Gerar Nota Fiscal</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                </v-list> -->
                <v-data-table
                    :headers="headers"
                    :items="veiculos"
                    :search="search"
                ></v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog width="800" v-model="system.diagCadVeiculo">
            <v-card class="pa-2">
                <v-card-title>
                    Cadastro de Veículo
                </v-card-title>
                <v-card-text>
                    <v-form>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Modelo"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Placa" v-mask="['XXXXXXX']"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="system.diagCadVeiculo = !system.diagCadVeiculo" dark>Cancelar</v-btn>
                    <v-btn color="primary" dark>Cadastrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Faturamento',
  data: () => ({
    system: {
        diagCadVeiculo: false
    },
    veiculos: [],
    headers: [
        { text: 'Modelo', value: 'modelo'},
        { text: 'Placa', value: 'placa' },
        { text: 'Chassi', value: 'chassi' },
        { text: 'Renavan', value: 'renavan' },
    ],
    search: "",
    empresas: [
        {empresa: "PALIO - MXP-5698"},
        {empresa: "DOBLÒ - GRD-3246"},
        {empresa: "SAVEIRO - GRD-5046"},
        {empresa: "PALIO - MXP-5798"},
        {empresa: "PALIO - MXP-5898"},
        {empresa: "PALIO - MXP-5998"}
    ]
  }),
  methods: {
      indexVeiculos () {
        this.axios.get('veiculos').then(respose => {
            this.veiculos = respose.data
        }).catch((e) => {
            alert(e.response.data)
        })
      },
      createVeiculo () {
        this.axios.post('veiculos').then(respose => {
            this.veiculos = respose.data
        }).catch((e) => {
            alert(e.response.data)
        })
      }
  },
  mounted(){
      this.indexVeiculos()
  }
}
</script>
